export const JuniperInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_COROMANDEL_QRCODE,
  DomainNames: [],
};

export const AlbasterInfo = {
  signInImage: '/assets/alabasterhomes-build-and-care-handover.jpg',
  logo: '/assets/Alabaster_Logo_White.png',
  loginLogo: '/assets/Alabaster_Logo_Grey.png',
  logoStyles: 'logo__img',
  paddingTop: 60,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms of this service and understand that any items outstanding will receive necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by Alabaster Homes during the 1 Year warranty period.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms of this service and understand that any items outstanding will receive necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by Alabaster Homes during the 1 Year warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: '',
  QRCode: import.meta.env.VITE_ALBASTER_QRCODE,
  DomainNames: ['https://homecare.alabasterhomes.ca'],
};

export const RizeInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-rize-color.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_RIZE_QRCODE,
  DomainNames: ['https://portal.rize.ca'],
};

export const DeficiencyGroupInfo = {
  signInImage: '/assets/dg-sign-in.jpg',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: '',
  QRCode: import.meta.env.VITE_DEFICIENCYGROUP_QRCODE,
  DomainNames: [],
};

export const StrandInfo = {
  signInImage: '/assets/strand-sign-in.jpg',
  logo: '/assets/strand-logo-white.png',
  loginLogo: '/assets/Strand-Logo-K.png',
  logoStyles: 'logo__strandimg',
  paddingTop: 35,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service, and understand that any items outstanding will receive the necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by Strand during the applicable warranty period.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service, and understand that any items outstanding will receive the necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by Strand during the applicable warranty period.',
  loader: '/assets/strandloader.gif',
  loginScreenDescription: '',
  QRCode: import.meta.env.VITE_STRAND_QRCODE,
  DomainNames: ['https://care.stranddev.com'],
};
export const FormwerksInfo = {
  signInImage: '/assets/formwerks-sign-in.png',
  logo: '/assets/Formwerks-logo-white.png',
  loginLogo: '/assets/Formwerks-logo.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 35,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //'By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.',
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner walkthrough and orientation and agree to the terms for this service and understand that all items noted in this document will receive the necessary attention. I also understand that all further warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: '',
  QRCode: import.meta.env.VITE_FORMWERKS_QRCODE,
  DomainNames: ['https://homecare.formwerksboutique.ca'],
};

export const OviedoInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "I acknowledge that I have inspected our new home and I agree that the descriptions of the items listed on this form are accurate. All features and components of the dwelling not specifically listed above as having deficiencies have been built and/or installed to my/our satisfaction, including all hard surfaces (ie. floors, countertops, tiles).Purchasers or owners who intend to designate someone to conduct the Homeowner Orientation in their place should ensure they provide written authority to the vendor/builder authorizing the designate to sign this form on their behalf.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'I acknowledge that I have inspected our new home and I agree that the descriptions of the items listed on this form are accurate. All features and components of the dwelling not specifically listed above as having deficiencies have been built and/or installed to my/our satisfaction, including all hard surfaces (ie. floors, countertops, tiles).Purchasers or owners who intend to designate someone to conduct the Homeowner Orientation in their place should ensure they provide written authority to the vendor/builder authorizing the designate to sign this form on their behalf.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_OVIEDO_QRCODE,
  DomainNames: ['https://oviedo.hellojuniper.co'],
};

export const ShapeInfo = {
  signInImage: '/assets/Shape_latest_loginImage.jpg',
  logo: '/assets/shape_logo_white.png',
  loginLogo: '/assets/shape_logo_black.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 39,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service, and understand that any items outstanding will receive the necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by Strand during the applicable warranty period.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service, and understand that any items outstanding will receive the necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by Strand during the applicable warranty period.',
  loader: '/assets/strandloader.gif',
  loginScreenDescription: '',
  QRCode: import.meta.env.VITE_SHAPE_QRCODE,
  DomainNames: ['https://customercare.shape.ca'],
};

export const QuadraInfo = {
  signInImage: '/assets/QuadraHomes.jpeg',
  logo: '/assets/Quadra-Logo-Dark.png',
  loginLogo: '/assets/Quadra-Logo.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service, and understand that any items outstanding will receive the necessary attention. I also understand that all other warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period. Any cosmetic defects, such as floor scratches, appliance dents, and wall gouges - must be noted at walkthrough or within 24 hours of possession date.  Anything logged into the portal after this date will be non-warrantable.',
  loader: '/assets/strandloader.gif',
  loginScreenDescription: '',
  QRCode: import.meta.env.VITE_QUADRA_QRCODE,
  DomainNames: ['https://customerservice.quadrahomes.com'],
};

export const PanatchInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/Panatch_group_horz_white.png',
  loginLogo: '/assets/Panatch_group_horz_Blue.png',
  logoStyles: 'logo__panatchimg',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By signing this document, I acknowledge that I have completed the deficiency review to the best of my understanding.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_PANATCH_QRCODE,
  DomainNames: ['https://homecare.panatchgroup.com'],
};

export const GateHouseInfo = {
  signInImage: '/assets/GateHouse-sign-in.png',
  logo: '/assets/gatehouse-logo-white.svg',
  loginLogo: '/assets/gatehouse-login-logo.svg',
  logoStyles: 'logo__panatchimg',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By signing this document, I acknowledge that I have completed the deficiency review to the best of my understanding.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/strandloader.gif',
  loginScreenDescription: 'Bringing exceptional service home',
  QRCode: import.meta.env.VITE_GATEHOUSE_QRCODE,
  DomainNames: ['https://homeowners.madebygatehouse.com'],
};

export const CoromandelInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  //"By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_COROMANDEL_QRCODE,
  DomainNames: ['https://app.hellojuniper.co'],
};

export const CanteraGroupInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_CANTERAGROUP_QRCODE,
  DomainNames: [
    'https://cantera.hellojuniper.co',
    'https://homeowners.canteragroup.com',
  ],
};

export const AragonInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ARAGON_QRCODE,
  DomainNames: ['https://customercare.aragon.ca'],
};

export const InterGulfInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_INTERGULF_QRCODE,
  DomainNames: [
    'https://intergulf.hellojuniper.co',
    'https://homeownercare.intergulf.com',
  ],
};

export const AsiaStandardAmericasInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ASIASTANDARD_QRCODE,
  DomainNames: [
    'https://asiastandardamericas.hellojuniper.co',
    'https://customercare.asiastandardamericas.com',
  ],
};

export const ITCConstructionGroupInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ITC_QRCODE,
  DomainNames: [
    'https://itc.hellojuniper.co',
    'https://customercare.itc-group.com',
  ],
};

export const EssenceInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ESSENCE_QRCODE,
  DomainNames: ['https://homecare.essenceliving.com'],
};

export const GableCraftInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_GABLECRAFT_QRCODE,
  DomainNames: [
    'https://gablecraft.hellojuniper.co',
    'https://customercare.gablecraft.ca',
    'https://customercare.royalbay.ca',
  ],
};

export const GairlochInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_GAIRLOCH_QRCODE,
  DomainNames: [
    'https://gairloch.hellojuniper.co',
    'https://homeownercare.gairloch.ca',
  ],
};

export const ZenterraInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ZENTERRA_QRCODE,
  DomainNames: ['https://homeownercare.zenterra.ca'],
};

export const JayenHomesInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_JAYENHOMES_QRCODE,
  DomainNames: [
    'https://jayenhomes.hellojuniper.co',
    'https://homeownercare.jayenproperties.com',
  ],
};

export const GableCraftMFInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_GABLECRAFT_MF_QRCODE,
  DomainNames: [
    'https://gablecraftmf.hellojuniper.co',
    'https://customerhappiness.gablecraft.ca',
    'https://customerhappiness.royalbay.ca',
    'https://homeownercare.royalbay.ca',
  ],
};

export const CamcosInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_CAMCOS_QRCODE,
  DomainNames: [
    'https://myliving.camcos.ca',
    'https://customerportal.camcos.ca',
  ],
};

export const EpicHomesInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_EPICHOMES_QRCODE,
  DomainNames: ['https://customercare.epichomes.info'],
};

export const BosaInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_BOSA_QRCODE,
  DomainNames: ['https://warrantyservices.bosadevelopment.com'],
};

export const PorteInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_PORTE_QRCODE,
  DomainNames: ['https://homeownercare.porte.ca'],
};

export const AmaconInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_AMACON_QRCODE,
  DomainNames: ['https://customercareto.amacon.com'],
};

export const GryphonInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_GRYPHON_QRCODE,
  DomainNames: ['https://customercare.gryphonliving.com'],
};

export const MetropiaInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_METROPIA_QRCODE,
  DomainNames: ['https://service.11yorkville.com'],
};

export const DemoInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_DEMO_QRCODE,
  DomainNames: ['https://demo.hellojuniper.co'],
};

export const ShapeRCInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ShapeRC_QRCODE,
  DomainNames: ['https://warrantycare.everythingatrc.com'],
};

export const QualexInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_QUALEX_QRCODE,
  DomainNames: ['https://homeownercare.qualex.ca'],
};

export const AnthemInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_ANTHEM_QRCODE,
  DomainNames: ['https://homeownercare.anthemproperties.com'],
};
export const TourInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_TOUR_QRCODE,
  DomainNames: ['https://tour.hellojuniper.co'],
};

export const WesgroupInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_WESGROUP_QRCODE,
  DomainNames: ['https://homeownercare.wesgroup.ca'],
};

export const FabricInfo = {
  signInImage: '/assets/sign-in.png',
  logo: '/assets/logo-white.svg',
  loginLogo: '/assets/logo-juniper-color@2x.png',
  logoStyles: 'logo__juniper_logo',
  paddingTop: 0,
  completeWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the walkthrough and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  // "By Clicking submit I accept terms and conditions of Pellentesque ullamcorper aliquet nisl, vitae, venenatis massa scelerisque vitaie.",
  completeHomeOwnerWalkThroughSignatureTermsAndConditions:
    'By signing this document, I acknowledge that I have completed the homeowner orientation and agree to the terms for this service. I understand that items noted as deficiencies will receive the necessary attention and warranty issues will be assessed and scheduled for repair as determined by the developer during the applicable warranty period.',
  loader: '/assets/Loader.gif',
  loginScreenDescription: 'Providing home and homeowner wellness',
  QRCode: import.meta.env.VITE_FABRIC_QRCODE,
  DomainNames: ['https://homeownercare.fabricliving.ca'],
};

const makeUrls = (tenantProductionDomainNames, tenant) => {
  var allDomainNamesATenantCouldBeIdentifiedBy = [];
  var maintenanceDomainNames = makeMaintenanceDomainNames(
    tenantProductionDomainNames
  );
  var juniperDomainNames = makeJuniperDomainNames(tenant);
  var localhostDomainNames = makeLocalhostDomains(tenant);

  allDomainNamesATenantCouldBeIdentifiedBy = [
    ...tenantProductionDomainNames,
    ...maintenanceDomainNames,
    ...juniperDomainNames,
    ...localhostDomainNames,
  ];

  return allDomainNamesATenantCouldBeIdentifiedBy;
};

const makeMaintenanceDomainNames = (tenantProductionDomainNames) => {
  var env = import.meta.env.VITE_ENVIRONMENT;
  return tenantProductionDomainNames.map(
    (prodDomain) => `${prodDomain}.maintenance.${env}.juniper.re`
  );
};

const makeJuniperDomainNames = (tenant, env) => {
  var env = import.meta.env.VITE_ENVIRONMENT;

  tenant = tenant.split(' ')[0];

  var juniperDomainNames = [];
  if (tenant == 'Coromandel') {
    juniperDomainNames.push(`https://app.${env}.juniper.re`);
  } else {
    juniperDomainNames.push(
      `https://${tenant.toLowerCase()}.app.${env}.juniper.re`
    );
  }

  return juniperDomainNames;
};

const makeLocalhostDomains = (tenant) => {
  var port = import.meta.env.PORT;
  tenant = tenant.split(' ')[0];

  var localhostDomains = [];
  if (tenant == 'Coromandel') {
    localhostDomains.push(`http://app.localhost:3000`);
  } else {
    localhostDomains.push(`http://${tenant.toLowerCase()}.app.localhost:3000`);
  }

  return localhostDomains;
};

export const tenants = [
  {
    id: '1',
    tenant: import.meta.env.VITE_JUNIPER,
    url: import.meta.env.VITE_JUNIPER_URL,
    urls: [],
    apiUrl: import.meta.env.VITE_API_JUNIPER_URL,
    analyticsKey: import.meta.env.VITE_JUNIPER_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_JUNIPER_HOTJAR_KEY,
    extraInfo: JuniperInfo,
  },
  {
    id: '2',
    tenant: import.meta.env.VITE_ALBASTER,
    url: import.meta.env.VITE_ALBASTER_URL,
    urls: makeUrls(AlbasterInfo.DomainNames, import.meta.env.VITE_ALBASTER),
    apiUrl: import.meta.env.VITE_API_ALBASTER_URL,
    analyticsKey: import.meta.env.VITE_ALBASTER_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ALBASTER_HOTJAR_KEY,
    extraInfo: AlbasterInfo,
    resolutionHeaderValue: import.meta.env.VITE_ALABASTER_RESOLUTION_HEADER,
  },
  {
    id: '3',
    tenant: import.meta.env.VITE_RIZE,
    url: import.meta.env.VITE_RIZE_URL,
    urls: makeUrls(RizeInfo.DomainNames, import.meta.env.VITE_RIZE),
    apiUrl: import.meta.env.VITE_API_RIZE_URL,
    analyticsKey: import.meta.env.VITE_RIZE_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_RIZE_HOTJAR_KEY,
    extraInfo: RizeInfo,
    resolutionHeaderValue: import.meta.env.VITE_RIZE_RESOLUTION_HEADER,
  },
  {
    id: '4',
    tenant: import.meta.env.VITE_DEFICIENCYGROUP_URL,
    url: import.meta.env.VITE_DEFICIENCYGROUP_URL,
    urls: makeUrls([], import.meta.env.VITE_DEFICIENCYGROUP_URL),
    apiUrl: import.meta.env.VITE_API_DEFICIENCYGROUP_URL,
    analyticsKey: import.meta.env.VITE_DEFICIENCYGROUP_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_DEFICIENCYGROUP_HOTJAR_KEY,
    extraInfo: DeficiencyGroupInfo,
  },
  {
    id: '5',
    tenant: import.meta.env.VITE_STRAND,
    url: import.meta.env.VITE_STRAND_URL,
    urls: makeUrls(StrandInfo.DomainNames, import.meta.env.VITE_STRAND),
    apiUrl: import.meta.env.VITE_API_STRAND_URL,
    analyticsKey: import.meta.env.VITE_STRAND_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_STRAND_HOTJAR_KEY,
    extraInfo: StrandInfo,
    resolutionHeaderValue: import.meta.env.VITE_STRAND_RESOLUTION_HEADER,
  },
  {
    id: '6',
    tenant: import.meta.env.VITE_SHAPE,
    url: import.meta.env.VITE_SHAPE_URL,
    urls: makeUrls(ShapeInfo.DomainNames, import.meta.env.VITE_SHAPE),
    apiUrl: import.meta.env.VITE_API_SHAPE_URL,
    analyticsKey: import.meta.env.VITE_SHAPE_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_SHAPE_HOTJAR_KEY,
    extraInfo: ShapeInfo,
    resolutionHeaderValue: import.meta.env.VITE_SHAPE_RESOLUTION_HEADER,
  },
  {
    id: '7',
    tenant: import.meta.env.VITE_COROMANDEL,
    url: import.meta.env.VITE_COROMANDEL_URL,
    urls: makeUrls(CoromandelInfo.DomainNames, import.meta.env.VITE_COROMANDEL),
    apiUrl: import.meta.env.VITE_API_COROMANDEL_URL,
    analyticsKey: import.meta.env.VITE_COROMANDEL_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_COROMANDEL_HOTJAR_KEY,
    extraInfo: CoromandelInfo,
    resolutionHeaderValue: import.meta.env.VITE_COROMANDEL_RESOLUTION_HEADER,
  },
  {
    id: '8',
    tenant: import.meta.env.VITE_PANATCH,
    url: import.meta.env.VITE_PANATCH_URL,
    urls: makeUrls(PanatchInfo.DomainNames, import.meta.env.VITE_PANATCH),
    apiUrl: import.meta.env.VITE_API_PANATCH_URL,
    analyticsKey: import.meta.env.VITE_PANATCH_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_PANATCH_HOTJAR_KEY,
    extraInfo: PanatchInfo,
    resolutionHeaderValue: import.meta.env.VITE_PANATCH_RESOLUTION_HEADER,
  },
  {
    id: '9',
    tenant: import.meta.env.VITE_FORMWERKS,
    url: import.meta.env.VITE_FORMWERKS_URL,
    urls: makeUrls(FormwerksInfo.DomainNames, import.meta.env.VITE_FORMWERKS),
    apiUrl: import.meta.env.VITE_API_FORMWERKS_URL,
    analyticsKey: import.meta.env.VITE_FORMWERKS_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_FORMWERKS_HOTJAR_KEY,
    extraInfo: FormwerksInfo,
    resolutionHeaderValue: import.meta.env.VITE_FORMWERKS_RESOLUTION_HEADER,
  },
  {
    id: '10',
    tenant: import.meta.env.VITE_OVIEDO,
    url: import.meta.env.VITE_OVIEDO_URL,
    urls: makeUrls(OviedoInfo.DomainNames, import.meta.env.VITE_OVIEDO),
    apiUrl: import.meta.env.VITE_API_OVIEDO_URL,
    analyticsKey: import.meta.env.VITE_OVIEDO_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_OVIEDO_HOTJAR_KEY,
    extraInfo: OviedoInfo,
    resolutionHeaderValue: import.meta.env.VITE_OVIEDO_RESOLUTION_HEADER,
  },
  {
    id: '11',
    tenant: import.meta.env.VITE_QUADRA,
    url: import.meta.env.VITE_QUADRA_URL,
    urls: makeUrls(QuadraInfo.DomainNames, import.meta.env.VITE_QUADRA),
    apiUrl: import.meta.env.VITE_API_QUADRA_URL,
    analyticsKey: import.meta.env.VITE_QUADRA_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_QUADRA_HOTJAR_KEY,
    extraInfo: QuadraInfo,
    resolutionHeaderValue: import.meta.env.VITE_QUADRA_RESOLUTION_HEADER,
  },
  {
    id: '12',
    tenant: import.meta.env.VITE_GATEHOUSE,
    url: import.meta.env.VITE_GATEHOUSE_URL,
    urls: makeUrls(GateHouseInfo.DomainNames, import.meta.env.VITE_GATEHOUSE),
    apiUrl: import.meta.env.VITE_API_GATEHOUSE_URL,
    analyticsKey: import.meta.env.VITE_GATEHOUSE_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_GATEHOUSE_HOTJAR_KEY,
    extraInfo: GateHouseInfo,
    resolutionHeaderValue: import.meta.env.VITE_GATEHOUSE_RESOLUTION_HEADER,
  },
  {
    id: '13',
    tenant: import.meta.env.VITE_CANTERAGROUP,
    url: import.meta.env.VITE_CANTERAGROUP_URL,
    urls: makeUrls(
      CanteraGroupInfo.DomainNames,
      import.meta.env.VITE_CANTERAGROUP
    ),
    apiUrl: import.meta.env.VITE_API_CANTERAGROUP_URL,
    analyticsKey: import.meta.env.VITE_CANTERAGROUP_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_CANTERAGROUP_HOTJAR_KEY,
    extraInfo: CanteraGroupInfo,
    resolutionHeaderValue: import.meta.env.VITE_CANTERA_RESOLUTION_HEADER,
  },
  {
    id: '14',
    tenant: import.meta.env.VITE_ARAGON_URL,
    urls: makeUrls(AragonInfo.DomainNames, import.meta.env.VITE_ARAGON_URL),
    apiUrl: import.meta.env.VITE_API_ARAGON_URL,
    analyticsKey: import.meta.env.VITE_ARAGON_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ARAGON_HOTJAR_KEY,
    extraInfo: AragonInfo,
    resolutionHeaderValue: import.meta.env.VITE_ARAGON_RESOLUTION_HEADER,
  },
  {
    id: '15',
    tenant: import.meta.env.VITE_INTERGULF,
    urls: makeUrls(InterGulfInfo.DomainNames, import.meta.env.VITE_INTERGULF),
    apiUrl: import.meta.env.VITE_API_INTERGULF_URL,
    analyticsKey: import.meta.env.VITE_INTERGULF_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_INTERGULF_HOTJAR_KEY,
    extraInfo: InterGulfInfo,
    resolutionHeaderValue: import.meta.env.VITE_INTERGULF_RESOLUTION_HEADER,
  },
  {
    id: '16',
    tenant: import.meta.env.VITE_ASIASTANDARDAMERICAS,
    urls: makeUrls(
      AsiaStandardAmericasInfo.DomainNames,
      import.meta.env.VITE_ASIASTANDARDAMERICAS
    ),
    apiUrl: import.meta.env.VITE_API_ASIASTANDARDAMERICAS_URL,
    analyticsKey: import.meta.env.VITE_ASIASTANDARDAMERICAS_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ASIASTANDARDAMERICAS_HOTJAR_KEY,
    extraInfo: AsiaStandardAmericasInfo,
    resolutionHeaderValue: import.meta.env.VITE_ASIASTANDARD_RESOLUTION_HEADER,
  },
  {
    id: '17',
    tenant: import.meta.env.VITE_ITCCONSTRUCTIONGROUP,
    urls: makeUrls(
      ITCConstructionGroupInfo.DomainNames,
      import.meta.env.VITE_ITCCONSTRUCTIONGROUP
    ),
    apiUrl: import.meta.env.VITE_API_ITCCONSTRUCTIONGROUP_URL,
    analyticsKey: import.meta.env.VITE_ITCCONSTRUCTIONGROUP_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ITCCONSTRUCTIONGROUP_HOTJAR_KEY,
    extraInfo: ITCConstructionGroupInfo,
    resolutionHeaderValue: import.meta.env.VITE_ITC_RESOLUTION_HEADER,
  },
  {
    id: '18',
    tenant: import.meta.env.VITE_ESSENCE,
    urls: makeUrls(EssenceInfo.DomainNames, import.meta.env.VITE_ESSENCE),
    apiUrl: import.meta.env.VITE_API_ESSENCE_URL,
    analyticsKey: import.meta.env.VITE_ESSENCE_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ESSENCE_HOTJAR_KEY,
    extraInfo: EssenceInfo,
    resolutionHeaderValue: import.meta.env.VITE_ESSENCE_RESOLUTION_HEADER,
  },

  {
    id: '19',
    tenant: import.meta.env.VITE_GABLECRAFT,
    urls: makeUrls(GableCraftInfo.DomainNames, import.meta.env.VITE_GABLECRAFT),
    apiUrl: import.meta.env.VITE_API_GABLECRAFT_URL,
    analyticsKey: import.meta.env.VITE_GABLECRAFT_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_GABLECRAFT_HOTJAR_KEY,
    extraInfo: GableCraftInfo,
    resolutionHeaderValue: import.meta.env.VITE_GABLECRAFT_RESOLUTION_HEADER,
  },
  {
    id: '20',
    tenant: import.meta.env.VITE_GAIRLOCH,
    urls: makeUrls(GairlochInfo.DomainNames, import.meta.env.VITE_GAIRLOCH),
    apiUrl: import.meta.env.VITE_API_GAIRLOCH_URL,
    analyticsKey: import.meta.env.VITE_GAIRLOCH_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_GAIRLOCH_HOTJAR_KEY,
    extraInfo: GairlochInfo,
    resolutionHeaderValue: import.meta.env.VITE_GAIRLOCH_RESOLUTION_HEADER,
  },
  {
    id: '21',
    tenant: import.meta.env.VITE_ZENTERRA,
    urls: makeUrls(ZenterraInfo.DomainNames, import.meta.env.VITE_ZENTERRA),
    apiUrl: import.meta.env.VITE_API_ZENTERRA_URL,
    analyticsKey: import.meta.env.VITE_ZENTERRA_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ZENTERRA_HOTJAR_KEY,
    extraInfo: ZenterraInfo,
    resolutionHeaderValue: import.meta.env.VITE_ZENTERRA_RESOLUTION_HEADER,
  },
  {
    id: '22',
    tenant: import.meta.env.VITE_JAYENHOMES,
    urls: makeUrls(JayenHomesInfo.DomainNames, import.meta.env.VITE_JAYENHOMES),
    apiUrl: import.meta.env.VITE_API_JAYENHOMES_URL,
    analyticsKey: import.meta.env.VITE_JAYENHOMES_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_JAYENHOMES_HOTJAR_KEY,
    extraInfo: JayenHomesInfo,
    resolutionHeaderValue: import.meta.env.VITE_JAYENHOMES_RESOLUTION_HEADER,
  },

  {
    id: '23',
    tenant: import.meta.env.VITE_GABLECRAFT_MF,
    urls: makeUrls(
      GableCraftMFInfo.DomainNames,
      import.meta.env.VITE_GABLECRAFT_MF
    ),
    apiUrl: import.meta.env.VITE_API_GABLECRAFT_MF_URL,
    analyticsKey: import.meta.env.VITE_GABLECRAFT_MF_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_GABLECRAFT_MF_HOTJAR_KEY,
    extraInfo: GableCraftMFInfo,
    resolutionHeaderValue: import.meta.env.VITE_GABLECRAFT_MF_RESOLUTION_HEADER,
  },
  {
    id: '24',
    tenant: import.meta.env.VITE_CAMCOS,
    urls: makeUrls(CamcosInfo.DomainNames, import.meta.env.VITE_CAMCOS),
    apiUrl: import.meta.env.VITE_API_CAMCOS_URL,
    analyticsKey: import.meta.env.VITE_CAMCOS_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_CAMCOS_HOTJAR_KEY,
    extraInfo: CamcosInfo,
    resolutionHeaderValue: import.meta.env.VITE_CAMCOS_RESOLUTION_HEADER,
  },
  {
    id: '25',
    tenant: import.meta.env.VITE_EPICHOMES,
    urls: makeUrls(EpicHomesInfo.DomainNames, import.meta.env.VITE_EPICHOMES),
    apiUrl: import.meta.env.VITE_API_EPICHOMES_URL,
    analyticsKey: import.meta.env.VITE_EPICHOMES_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_EPICHOMES_HOTJAR_KEY,
    extraInfo: EpicHomesInfo,
    resolutionHeaderValue: import.meta.env.VITE_EPICHOMES_RESOLUTION_HEADER,
  },
  {
    id: '26',
    tenant: import.meta.env.VITE_BOSA,
    urls: makeUrls(BosaInfo.DomainNames, import.meta.env.VITE_BOSA),
    apiUrl: import.meta.env.VITE_API_BOSA_URL,
    analyticsKey: import.meta.env.VITE_BOSA_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_BOSA_HOTJAR_KEY,
    extraInfo: BosaInfo,
    resolutionHeaderValue: import.meta.env.VITE_BOSA_RESOLUTION_HEADER,
  },

  {
    id: '27',
    tenant: import.meta.env.VITE_PORTE,
    urls: makeUrls(PorteInfo.DomainNames, import.meta.env.VITE_PORTE),
    apiUrl: import.meta.env.VITE_API_PORTE_URL,
    analyticsKey: import.meta.env.VITE_PORTE_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_PORTE_HOTJAR_KEY,
    extraInfo: PorteInfo,
    resolutionHeaderValue: import.meta.env.VITE_PORTE_RESOLUTION_HEADER,
  },
  {
    id: '28',
    tenant: import.meta.env.VITE_AMACON,
    urls: makeUrls(AmaconInfo.DomainNames, import.meta.env.VITE_AMACON),
    apiUrl: import.meta.env.VITE_API_AMACON_URL,
    analyticsKey: import.meta.env.VITE_AMACON_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_AMACON_HOTJAR_KEY,
    extraInfo: AmaconInfo,
    resolutionHeaderValue: import.meta.env.VITE_AMACON_RESOLUTION_HEADER,
  },
  {
    id: '29',
    tenant: import.meta.env.VITE_GRYPHON,
    urls: makeUrls(GryphonInfo.DomainNames, import.meta.env.VITE_GRYPHON),
    apiUrl: import.meta.env.VITE_API_GRYPHON_URL,
    analyticsKey: import.meta.env.VITE_GRYPHON_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_GRYPHON_HOTJAR_KEY,
    extraInfo: GryphonInfo,
    resolutionHeaderValue: import.meta.env.VITE_GRYPHON_RESOLUTION_HEADER,
  },
  {
    id: '30',
    tenant: import.meta.env.VITE_METROPIA,
    urls: makeUrls(MetropiaInfo.DomainNames, import.meta.env.VITE_METROPIA),
    apiUrl: import.meta.env.VITE_API_METROPIA_URL,
    analyticsKey: import.meta.env.VITE_METROPIA_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_METROPIA_HOTJAR_KEY,
    extraInfo: MetropiaInfo,
    resolutionHeaderValue: import.meta.env.VITE_METROPIA_RESOLUTION_HEADER,
  },
  {
    id: '31',
    tenant: import.meta.env.VITE_DEMO,
    urls: makeUrls(DemoInfo.DomainNames, import.meta.env.VITE_DEMO),
    apiUrl: import.meta.env.VITE_API_DEMO_URL,
    analyticsKey: import.meta.env.VITE_DEMO_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_DEMO_HOTJAR_KEY,
    extraInfo: DemoInfo,
    resolutionHeaderValue: import.meta.env.VITE_DEMO_RESOLUTION_HEADER,
  },
  {
    id: '32',
    tenant: import.meta.env.VITE_ShapeRC,
    urls: makeUrls(ShapeRCInfo.DomainNames, import.meta.env.VITE_ShapeRC),
    apiUrl: import.meta.env.VITE_API_ShapeRC_URL,
    analyticsKey: import.meta.env.VITE_ShapeRC_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ShapeRC_HOTJAR_KEY,
    extraInfo: ShapeRCInfo,
    resolutionHeaderValue: import.meta.env.VITE_ShapeRC_RESOLUTION_HEADER,
  },
  {
    id: '33',
    tenant: import.meta.env.VITE_QUALEX,
    urls: makeUrls(QualexInfo.DomainNames, import.meta.env.VITE_QUALEX),
    apiUrl: import.meta.env.VITE_API_QUALEX_URL,
    analyticsKey: import.meta.env.VITE_QUALEX_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_QUALEX_HOTJAR_KEY,
    extraInfo: QualexInfo,
    resolutionHeaderValue: import.meta.env.VITE_QUALEX_RESOLUTION_HEADER,
  },
  {
    id: '34',
    tenant: import.meta.env.VITE_ANTHEM,
    urls: makeUrls(AnthemInfo.DomainNames, import.meta.env.VITE_ANTHEM),
    apiUrl: import.meta.env.VITE_API_ANTHEM_URL,
    analyticsKey: import.meta.env.VITE_ANTHEM_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_ANTHEM_HOTJAR_KEY,
    extraInfo: AnthemInfo,
    resolutionHeaderValue: import.meta.env.VITE_ANTHEM_RESOLUTION_HEADER,
  },
  {
    id: '35',
    tenant: import.meta.env.VITE_TOUR,
    urls: makeUrls(TourInfo.DomainNames, import.meta.env.VITE_TOUR),
    apiUrl: import.meta.env.VITE_API_TOUR_URL,
    analyticsKey: import.meta.env.VITE_TOUR_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_TOUR_HOTJAR_KEY,
    extraInfo: TourInfo,
    resolutionHeaderValue: import.meta.env.VITE_TOUR_RESOLUTION_HEADER,
  },
  {
    id: '36',
    tenant: import.meta.env.VITE_WESGROUP,
    urls: makeUrls(WesgroupInfo.DomainNames, import.meta.env.VITE_WESGROUP),
    apiUrl: import.meta.env.VITE_API_WESGROUP_URL,
    analyticsKey: import.meta.env.VITE_WESGROUP_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_WESGROUP_HOTJAR_KEY,
    extraInfo: WesgroupInfo,
    resolutionHeaderValue: import.meta.env.VITE_WESGROUP_RESOLUTION_HEADER,
  },
  {
    id: '37',
    tenant: import.meta.env.VITE_FABRIC,
    urls: makeUrls(FabricInfo.DomainNames, import.meta.env.VITE_FABRIC),
    apiUrl: import.meta.env.VITE_API_FABRIC_URL,
    analyticsKey: import.meta.env.VITE_FABRIC_ANALYTICS_KEY,
    hotjarKey: import.meta.env.VITE_FABRIC_HOTJAR_KEY,
    extraInfo: FabricInfo,
    resolutionHeaderValue: import.meta.env.VITE_FABRIC_RESOLUTION_HEADER,
  },
];
